<template>
  <div class="v-orders container">
    <!-- action-bar -->
    <action-bar class="head-bar action-bar">
      <div class="left" slot="left">
        <button @click.stop="$router.push('/home/hall')">{{'购彩大厅'}}</button>
      </div>

      <div class="title" slot="title">
        <span>{{'未结明细'}}</span>
      </div>
    </action-bar>

    <!-- main-table -->
    <div class="v-main">
        <v-table :data="data" :columns="columns" @goto="goto">
          <span slot="count" slot-scope="{row}">{{row.count}}</span>
        </v-table>
    </div>

    <!--  -->
    <div class="count-box">
      <p>
        共<span class="red">{{allcount}}</span>注，投注额 <span class="red">{{bet_money}}</span>元，佣金 <span class="red">{{commission}}</span>元，输赢 <span class="red">{{result}}</span>元
      </p>
    </div>
  </div>
</template>

<script>
  import ActionBar from '@/components/action-bar';
  import VTable from '@/components/table';
  import {unsettle} from '@/service/report';
  export default {
    name: "v-orders",
    components: {ActionBar, VTable},
    data () {
      return {
        data: [],
        allcount:0,
        bet_money:0,
        commission:0,
        result:0
      }
    },

     created(){
        unsettle().then(res=>{
            this.data = res.data.map(item=>{
              //  item.results = item.result>= 0?'<span style="color:red" >'+item.result+'</span>' :'<span style="color:#0f0" >'+item.result+'</span>';
                item.lottery_names = '<span style="color:blue" >'+item.lottery_name+'</span>';
                return item;
            });



            let allcount =0; 
            let bet_money = 0; 
            let commission = 0 ;
            let result = 0;

            this.data.forEach(item=>{
                allcount +=  item.count;
                bet_money += item.bet_money;
                commission += item.commission;
                result += item.result;
            })

            this.allcount = allcount;
            this.bet_money = bet_money;
            this.commission = commission;
            this.result = result;
        });
    },

    methods:{
        goto(item){
             this.$router.push({path:'/home/orderDetail',query: item})
        }
    },

    computed: {
      columns () {
        return [
          {
            title: '彩种类型',
            key: 'lottery_names',
            width: '40%',
            align: 'center'
          },
          {
            title: '注数',
            key: 'count',
            width: '20%',
            align: 'center'
          },
          {
            title: '下注金额',
            key: 'bet_money',
            width: '20%',
            align: 'center'
          },
          {
            title: '有效金额',
            key: 'bet_money_real',
            width: '20%',
            align: 'center'
          }
        ]
      }
    }
  }
</script>

<style scoped lang="less">
  .v-orders{
    .head-bar {
      z-index: 100;
      position: relative;

      .left {
        width: 140px;

        > button {
          height: 60px;
        }
      }

      .title {
        display: flex;
        text-align: center;
        align-items: center;
        font-weight: bold;
        justify-content: center;

        > button {
          width: 50px;
          height: 50px;
          border: 1px solid #b40f06;
          position: relative;
          margin-left: 10px;
          border-radius: 25px;

          &:after {
            top: 22px;
            left: 13px;
            display: block;
            content: "";
            position: absolute;
            border-top: 10px solid #fff;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: none;
            transition: transform 0.2s linear;
          }
        }
      }


      button {
        color: #fff;
        border: 1px solid #b70a00;
        padding: 0 16px;
        position: relative;
        font-size: 24px;
        background: #e8291d;
        background: -webkit-gradient(linear, 0 0, 0 70%, from(#f94539), to(#e8291d));
        box-shadow: 0 2px 2px #fc7f77 inset;
        border-radius: 10px;
      }
    }
    .v-main{
      position: relative;
      box-sizing: border-box;
      padding-bottom: 60px;
    }
    .count-box{
      height: 100px;
      font-size: 24px;
      background: #fffbec;
      flex-shrink: 0;
      border-top: 1px solid #dfdddd;
      box-sizing: border-box;
      p{
        height: 50px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e2d9b5;
        justify-content: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/orders/index.vue